/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { useNavigate } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
// import { motion } from 'framer-motion';
// eslint:fix motion is defined but is never used
import compact from 'lodash/compact';
const { selectDesktop } = Slices.appSlice;
const { selectBaseURL, selectCountryValidations } = Slices.configSlice;
const { selectProductEntities } = Slices.productSlice;
import Loader from '../../components/Loader';
const {
  addCustomizeCart,
  updateCustomizeItem,
  updateCustomizeItemValue,
  addCustomize,
} = Slices.tempCartSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { sendCart } = Slices.cartSlice;
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import DialogBox from '../../components/DialogBox';
import css from './index.module.scss';

import ProductCustomize from './ProductCustomize.jsx';
const { selectDefaultAddress } = Slices.addressSlice;
const { offerApplied } = Slices.offerSlice;
import { any } from 'prop-types';
function Customize({
  onAddToCart,
  locale,
  encodedCategoryName,
  categoryID,
  encodedProductName,
  productID,
  cartID,
}) {
  const dispatch = useDispatch();
  const navigateHook = useNavigate();
  const isDesktop = useSelector(selectDesktop);
  const customizeItem = useSelector((state) => state.tempCart);
  const productsMap = useSelector(selectProductEntities);
  const address = useSelector(selectDefaultAddress);
  const cart = useSelector((state) => state.cart);
  // const offer = useSelector((state) => state.offer);
  // eslint:fix
  // const CustomID = useState(uuidv4());
  // eslint:fix CustomId is defined but never used
  const countryName = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const profile = useSelector((state) => state.profile);
  // const menu = useSelector(selectFirstMenu);
  // eslint:fix menu is declared but its value is never read
  const [mainVal, setMainVal] = useState(0);
  const [pageLoader] = useState(false);
  // eslint:fix setPageLoader is removed as it not used
  const [resetDependent, SetResetDependent] = useState(false);
  const offerSelected = useSelector(offerApplied);

  //const cartId = useSelector(selectAuthId);
  // const customCartId = auth.isProfileCreated ? cartId : auth.draft.cartId;
  const imgBaseUrl = useSelector(selectBaseURL);
  // const couponCode = offer.apply ? offer.apply.couponCode : '';
  // eslint:fix couponCode is assigned a value but never used
  const [selectedProduct, setSelectedProduct] = useState(cart.data?.items[cartID]);
  const [selectedSize, setSelectedSize] = useState(null);
  // const [custID, setCustID] = useState(productID);
  // eslint:fix
  const [refArray, setRefArray] = useState([]);
  const executeScroll = (ref) => {
    ref.current.scrollIntoView();
  };
  // REV : add to cart function
  const addCart = () => {
    const valItem = Object.assign({}, cart.data?.items[cartID]);
    let mainItem = valItem;
    const getCustIndex = customizeItem.data.items.findIndex(({ id }) => id === selectedProduct?.id);
    const customItem = getCustIndex !== -1 ? customizeItem.data.items[getCustIndex] : {};
    let other = [];
    if (mainItem.items.length !== 0) {
      mainItem.items.forEach((value, loopId) => {
        if (value.sku === customItem.sku) {
          other.push(customizeItem.data.items[getCustIndex]);
        } else {
          other.push(productsMap[value.id]);
        }
      });
      mainItem.items = other;
    } else {
      mainItem = customizeItem.data.items[getCustIndex];
    }
    let configBundle = [];
    if (mainItem.configurableProductOptions.length) {
      configBundle = [...mainItem.configurableProductOptions];
      const checked =
        configBundle.length &&
        configBundle[0].options.map((val) => {
          let groupVal = { ...val };
          if (val.id === customizeItem.data.items[getCustIndex].sel1Value) {
            groupVal = { ...groupVal, isSelected: 1 };
          } else {
            groupVal = { ...groupVal, isSelected: 0 };
          }
          return groupVal;
        });
      configBundle[0] = { ...configBundle[0], options: checked };
    }
    mainItem = {
      ...mainItem,
      calculatedPrice: customizeItem.data.items[getCustIndex].tempPrice,
      bundleProductOptions: customizeItem.data.items[getCustIndex].bundleProductOptions,
      sellingPrice: mainItem.qty * customizeItem.data.items[getCustIndex].tempPrice,
      selectedItem: customizeItem.data.items[getCustIndex].sku,
      tempPrice: customizeItem.data.items[getCustIndex].tempPrice,
      configurableProductOptions: configBundle,
      items: other,
      customized: true,
    };

    let items = [...cart.data.items];
    items[cartID] = mainItem;
    // delete items[cartID];
    // items.push(mainItem);

    let addressType = 'DELIVERY';
    let addressSubType = 'STORE';
    if (Object.entries(address).length) {
      addressType = address.addressType;
      addressSubType = address.addressSubType;
    }

    const payload = {
      body: {
        addressSubType: addressSubType,
        addressType: addressType,
        addressId: address?.id || '',
        cartId: profile?.data?.data[0]?.cartId,
        couponCode: cart?.data?.promo?.couponCode || offerSelected?.couponCode || '',
        curMenuId: countryValidations?.defaultMenuId || 0,
        curMenuTemplateId: countryValidations?.defaultMenuTempId || 0,
        items: compact(items),
        lat: 25.235519409179688,
        lng: 55.277530670166016,
        menuUpdatedAt: Date.now(),
        menuVersion: 'v1',
        orderType: addressType,
        reorder: false,
      },
      headers: {
        country: profile.data.data[0].country,
      },
    };
    dispatch(sendCart(payload));
    dispatch(updateCustomizeItemValue(mainItem));

    navigateHook(-1);
  };
  const resetAddOns = () => {
    const mainItem = productsMap[productID];
    let other = [];
    // let itemList = [];
    // eslint:fix
    mainItem.items.length &&
      mainItem.items.forEach((val) => {
        other.push(productsMap[val]);
        // itemList.push(val);
        console.log(`1) addCustomize call  --- `, productsMap[val]);
        dispatch(addCustomize(productsMap[val]));
      });
    let payload = {
      ...productsMap[productID],
      items: other,
      tempPrice: productsMap[productID].finalPrice,
      qty: cart.data?.items[cartID].qty,
    };
    console.log(`2) addCustomize call --- `, payload);
    dispatch(addCustomize(payload));
    SetResetDependent(true);
  };

  useEffect(() => {
    if (selectedProduct && cart.status === 'succeeded') {
      let price = 0;
      if (cart.data?.items[cartID]) {
        price = cart.data?.items[cartID].sellingPrice / cart.data?.items[cartID].qty;
      }
      let isDone = false;
      if (selectedProduct.typeId === 'bundle_group') {
        selectedProduct.items.forEach((val) => {
          if (val.sku === selectedProduct.selectedItem) {
            dispatch(addCustomizeCart({ product: val, priceVal: price }));
            setMainVal(val.id);
          } else {
            setMainVal(val.id);
            dispatch(
              addCustomizeCart({
                product: val,
                priceVal: val.sellingPrice / cart.data?.items[cartID].qty,
              })
            );
          }
        });
        isDone = true;
      } else {
        const getCustIndex = customizeItem.data.items.findIndex(
          ({ id }) => id === selectedProduct?.id
        );
        if (getCustIndex === -1) {
          dispatch(
            addCustomizeCart({
              product: selectedProduct,
              priceVal: selectedProduct.sellingPrice / cart.data?.items[cartID].qty,
            })
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct, cart.status]);

  useEffect(() => {
    const valItem = Object.assign({}, cart.data?.items[cartID]);
    let priceData = valItem.sellingPrice || valItem.finalPrice;
    if (valItem.qty !== 1) {
      priceData = priceData / valItem.qty;
    }
    const newPro = { ...valItem, tempPrice: priceData };
    dispatch(updateCustomizeItem(newPro));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartID]);

  useEffect(() => {
    const customizeIndex = customizeItem.data.items.findIndex(({ id }) => id === mainVal);
    if (customizeIndex !== -1 && cart.status === 'succeeded') {
      setSelectedProduct(customizeItem.data.items[customizeIndex]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainVal, cart.status]);
  // TODO: remove unnecessary conditions -- update selected item on selection of size

  useEffect(() => {
    if (
      selectedSize &&
      selectedSize !== -1 &&
      selectedProduct &&
      selectedProduct.sel1Value !== selectedSize.id
    ) {
      const { items } = productsMap[productID];
      const selected = items.reduce((acc, curr) => {
        const newCurr = curr.id ? curr.id : curr;
        return productsMap[newCurr].sel1Value === selectedSize.id ? productsMap[newCurr] : acc;
      }, null);
      setSelectedProduct(selected);
    }
  }, [customizeItem.data.items, dispatch, productID, productsMap, selectedProduct, selectedSize]);

  const customizeIndex = customizeItem.data.items.findIndex(({ id }) => id === selectedProduct?.id);
  const menuItem = selectedProduct ? productsMap[selectedProduct.id] : {};

  return !selectedProduct ? null : (
    <>
      {!isDesktop && (
        <div className={css.root}>
          {pageLoader && <Loader />}
          <Header
            title={menuItem.name}
            actionButtons={[
              <LanguageButton />,
              <Button
                variant="outlined"
                size="small"
                className={css.resetBtn}
                onClick={resetAddOns}
              >
                <FormattedMessage id="customize_reset" defaultMessage="Reset" />
              </Button>,
            ]}
          />

          <ProductCustomize
            SetResetDependent={SetResetDependent}
            resetDependent={resetDependent}
            menuItem={menuItem}
            refArray={refArray}
            imgBaseUrl={imgBaseUrl}
            selectedProduct={selectedProduct}
            setSelectedSize={setSelectedSize}
            setRefArray={setRefArray}
            addCart={addCart}
            customizeItem={customizeItem}
            customizeIndex={customizeIndex}
            productID={productID}
            categoryID={categoryID}
            resetButton={resetAddOns}
          />
        </div>
      )}
      {isDesktop && (
        <DialogBox
          maxWidth="190rem"
          title={
            <FormattedMessage id="customize_your_meals" defaultMessage="Customize your Meal " />
          }
          size="lg"
          isOpen={true}
          onClose={() => navigateHook(-1)}
          height={'80vh'}
        >
          <div className={css.desktopWrapper}>
            <ProductCustomize
              menuItem={menuItem}
              isDesktop={isDesktop}
              executeScroll={executeScroll}
              refArray={refArray}
              imgBaseUrl={imgBaseUrl}
              selectedProduct={selectedProduct}
              setSelectedSize={setSelectedSize}
              setRefArray={setRefArray}
              addCart={addCart}
              productID={productID}
              customizeItem={customizeItem}
              customizeIndex={customizeIndex}
              resetButton={resetAddOns}
            />
          </div>
        </DialogBox>
      )}
    </>
  );
}

export default Customize;
